/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import useMedia from 'use-media'

const linkCss = (isActive, marginTop) => css`
  display: flex;
  align-items: center;
  height: 50px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  position: relative;

  ${marginTop &&
  css`
    border-top: 1px solid #d8dee5;
    margin-top: auto;
  `};

  ${isActive &&
  css`
    color: #3f8cff;
    font-weight: 400;
  `};

  @media (max-width: 855px) {
    border-top: 1px solid #d8dee5;
  }

  :hover {
    background-color: rgba(0, 0, 0, 0.03);
  }

  .icon {
    margin-left: 10px;
    width: 12px;

    ${isActive &&
    css`
      > path {
        fill: #3f8cff;
      }
    `};
  }

  .label {
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
  }

  .new-label {
    position: absolute;
    right: 10px;
    top: 15px;
    background-color: #4384f5;
    color: white;
    font-size: 10px;
    border-radius: 10px;
    padding: 5px 10px;
    font-weight: 500;
  }
`

const Link = ({
  name,
  onClick,
  icon: Icon,
  isActive,
  marginTop,
  withNewLabel,
}) => {
  const isSmall = useMedia({ maxWidth: 855 })

  return (
    <div
      css={linkCss(isActive, marginTop)}
      onClick={onClick}
      data-cy={`navigation-${name}`}
    >
      <Icon className="icon" />
      <span className="label">
        {name.charAt(0).toUpperCase() + name.slice(1)}
      </span>
      {withNewLabel && !isSmall && <div className="new-label">NEW!</div>}
    </div>
  )
}

export default Link
